module.exports = __webpack_public_path__ + "img/4.1862a8b4.jpg";